import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import authAxios from '@services/authAxios';

export const useGetCustomerList = ({ page, limit, search, id }) => {
    return useQuery({
        queryKey: ['customer-list', { page, limit, search, id }],
        queryFn: async () => {
            const { data } = await authAxios.get(`/api/v1/promotion-claim/customer-list`, {
                params: {
                    limit,
                    page,
                    search,
                    ...(id ? { promotion_id: id } : {}),
                },
            });
            return data;
        },
        select: ({ data }) => {
            return data;
        },
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
        enabled: !!id || !!search,
    });
};

const fetchCustomer = async ({ pageParam, queryKey }) => {
    const [_key, { search, promotion_id }] = queryKey;
    const { data } = await authAxios.get('/api/v1/promotion-claim/customer-list', {
        params: { page: pageParam, limit: 20, search, promotion_id, is_master: true },
    });
    return data;
};

export const useGetInfiniteCustomerList = (search, promotion_id) => {
    return useInfiniteQuery({
        queryKey: ['customer-list', { search, promotion_id }],
        queryFn: fetchCustomer,
        select: (data) => {
            const structuredData = data?.pages.flatMap((page) =>
                page.data.page_data.map((item) => ({
                    ...item,
                    id: item.customer_id,
                }))
            );
            return structuredData;
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages) => {
            if (lastPage?.data?.current_page < lastPage?.data?.total_page) {
                return lastPage?.data?.current_page + 1;
            }
            return undefined;
        },
        enabled: !!search,
    });
};

export const useGetCustomerDetail = (id, params) => {
    return useQuery({
        queryKey: ['customer-list', 'detail', { id, ...params }],
        queryFn: async () => {
            const { data } = await authAxios.get(`/api/v1/promotion-claim/detail/customer/${id}/sellout`, { params });
            return data;
        },
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
    });
};
